import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionDescription(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.aboutDescription)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h2 className={classes.description, classes.textCenter}>
            VALUATION & ADVISORY SERVICES
          </h2>
          <h3>SERVICES FOR INVESTORS</h3>
          <h5>Kinos provides comprehensive valuation, advisory and consulting services for real estate owners, investors and lenders, combining our specialized expertise and premier technologies to deliver industry-leading valuation reports and analysis.</h5>
          <h5>Calculate the real value of your asset or portfolio in any sector, anywhere in the Spain. Get a fast, reliable, and accurate assessment from licensed professionals for even the most complex projects.
          </h5>
          <h5>Unrivaled, Industry-Leading Expertise
At Kinos, we understand that accurate and reliable valuations are critical to the success of every real estate investment, which is why we offer our clients unique perspectives and access to the largest valuation database and the most valuable proprietary data in the industry.
We use our extensive global scale, state-of-the art technology and proven innovation processes to deliver exceptional valuation, advisory and consulting services across all property types and geographies Kinoss global valuation partners experts, located across all geographies, allow for customized client solutions for individual assets or multiple property portfolios.
We leverage our unparalleled perspectives, innovation and scale to deliver leading valuation, advisory and consulting services, enabling our clients to make informed business decisions.
</h5>
<h5>
Understand and optimize value
Arriving at an opinion of a propertys value is a complex and disciplined process that can significantly impact your business. A well-supported appraisal is often a necessary step in securing a loan, choosing the best asset for your portfolio and closing a sale.
</h5>
<h5>
Achieving a credible valuation report that complies with a clients requirements and all applicable professional standards and regulations requires qualified professionals and a nuanced understanding of the property and broader market trends. Our team and partners can provide vital insights into all property types real estate assets.
Valuation & Advisory Sectors
</h5>
<h5>
Our extensive, industry leading, global platform enables us to consistently provide quality assurance on a wide range of services across many different property. </h5>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(descriptionStyle)(SectionDescription);
